import { FormEvent } from 'react';
import { FormControl, FormGroup, Panel } from 'react-bootstrap';

interface IProps {
    adminComments: string,
    centerId: number,
    donorId: number,
    onChange: (e: FormEvent<FormControl & HTMLInputElement>) => void
}

const Comments = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>
                Add a New Administrative Comment
            </Panel.Heading>
            <Panel.Body>
                <span style={{ fontSize: 12 }}>(Do not enter medical notes here, they go in the <a href={'center/' + props.centerId + '/donor/' + props.donorId + '/profile/medical-details'}>medical details</a> tab. Administrative comments are not visible to other centers.)</span>
                <FormGroup>
                    <FormControl
                        componentClass='textarea'
                        cols={30}
                        rows={8}
                        style={{ width: '100%', height: 120 }}
                        name='adminComments'
                        value={props.adminComments}
                        onChange={props.onChange} />

                    <span style={{ color: 'red', fontSize: 12, lineHeight: '1em' }}>Admin Comments are for managing center use only. NKR and other centers can not see these comments.</span>
                </FormGroup>
            </Panel.Body>
        </Panel>
    );
}

export default Comments;